<template>
    <v-container>
        <v-row>
            <v-col cols="12" md="6" lg="4">
                <v-select
                        v-model="period"
                        :items="allPeriods"
                        :item-text="el => $t(el.name)"
                        item-value="id"
                        :label="$t('dash.period')"
                        outlined
                ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" lg="4">
                <v-menu
                        v-model="modalDate1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="compareDateRangeText1"
                                :label="$t('dash.period1')"
                                readonly
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="compareDates1"
                            range
                            :locale="$i18n.locale"
                            color="primary"
                            no-title
                    >
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="6" lg="4">
                <v-menu
                        v-model="modalDate2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="compareDateRangeText2"
                                :label="$t('dash.period2')"
                                readonly
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            v-model="compareDates2"
                            range
                            :locale="$i18n.locale"
                            color="primary"
                            no-title
                    >
                    </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6" lg="4">
                <v-autocomplete
                        v-if="isLoginUserSuperAdmin()"
                        v-model="organisation"
                        :items="allOrganisations"
                        item-text="name"
                        item-value="id"
                        :label="$t('anOrganization')"
                        outlined
                        :no-data-text="$t('noDataAvailable')"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="1" lg="4"></v-col>
            <v-col cols="12" class="d-flex justify-end">
                <v-btn class="btn-one mr-3" height="56px"
                       @click="cancel()">
                    <span>{{ $t('cancel') }}</span>
                </v-btn>
                <v-btn class="btn-two" color="#08a657" height="56px"
                       @click="compare()">
                    <span>{{ $t('apply') }}</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        components: {},
        name: "CompareFilter",
        props: ['applyFilter', 'allOrganisations', 'compareDate', 'organizationId'],
        data() {
            return {
                compareDates1: [],
                compareDates2: [],
                organisation: '',
                period: 1,
                allPeriods: [
                    {id: null, name: 'dash.customPeriod'},
                    {id: 0, name: 'dash.week'},
                    {id: 1, name: 'dash.month'},
                    {id: 2, name: 'dash.quarter'},
                    {id: 3, name: 'dash.year'}
                ],
                modalDate1: false,
                modalDate2: false,
            }
        },
        computed: {
            compareDateRangeText1() {
                return this.compareDates1.join(' - ')
            },
            compareDateRangeText2() {
                return this.compareDates2.join(' - ')
            },
        },
        methods: {
            compare() {
                let compareDate = {
                    dateTimeBegin1: this.compareDates1[0],
                    dateTimeEnd1: this.compareDates1[1],
                    dateTimeBegin2: this.compareDates2[0],
                    dateTimeEnd2: this.compareDates2[1],
                }
                this.applyFilter(compareDate, this.organisation);

            },
            cancel() {
                this.$router.push({name: 'dashboard'})
            },
            isLoginUserSuperAdmin() {
                return localStorage.getItem('role').toLocaleLowerCase() === 'super admin' || localStorage.getItem('role').toLocaleLowerCase() === 'super admin plus'
            },
            setCurrentPeriods(type) {
                const date = new Date();
                let y = date.getFullYear(),
                    m = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1,
                    d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                switch (type) {
                    case 0: {
                        const d1 = parseDateToStr(date - (13 * 24 * 60 * 60 * 1000)),
                            d2 = parseDateToStr(date - (7 * 24 * 60 * 60 * 1000)),
                            d3 = parseDateToStr(date - (6 * 24 * 60 * 60 * 1000)),
                            d4 = parseDateToStr(date);
                        this.compareDates1 = [d1, d2];
                        this.compareDates2 = [d3, d4];
                        break;
                    }
                    case 1: {
                        this.compareDates2 = [`${y}-${m}-01`, `${y}-${m}-${d}`];
                        if (m === '01') {
                            y--;
                            m = 12;
                        } else {
                            m = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth();
                        }
                        const daysInMonth = 33 - new Date(y, m - 1, 33).getDate();
                        this.compareDates1 = [`${y}-${m}-01`, `${y}-${m}-${daysInMonth}`];
                        break;
                    }
                    case 2: {
                        const q = {
                            first: [`${y}-01-01`, `${y}-03-31`],
                            second: [`${y}-04-01`, `${y}-06-30`],
                            third: [`${y}-07-01`, `${y}-09-30`],
                            fourth: [`${y}-10-01`, `${y}-12-31`],
                        };
                        switch (m) {
                            case '01':
                            case '02':
                            case '03': {
                                this.compareDates2 = [q.first[0], `${y}-${m}-${d}`];
                                y--;
                                this.compareDates1 = [`${y}-10-01`, `${y}-12-31`];
                                break;
                            }
                            case '04':
                            case '05':
                            case '06': {
                                this.compareDates2 = [q.second[0], `${y}-${m}-${d}`];
                                this.compareDates1 = q.first;
                                break;
                            }
                            case '07':
                            case '08':
                            case '09': {
                                this.compareDates2 = [q.third[0], `${y}-${m}-${d}`];
                                this.compareDates1 = q.second;
                                break;
                            }
                            case '10':
                            case '11':
                            case '12': {
                                this.compareDates2 = [q.fourth[0], `${y}-${m}-${d}`];
                                this.compareDates1 = q.third;
                                break;
                            }
                            default:
                                break;
                        }
                        break;
                    }
                    case 3: {
                        this.compareDates1 = [`${y - 1}-01-01`, `${y - 1}-12-31`];
                        this.compareDates2 = [`${y}-01-01`, `${y}-${m}-${d}`];
                        break;
                    }
                    default:
                        break;

                }

                function parseDateToStr(dt) {
                    const date = new Date(dt),
                        y = date.getFullYear(),
                        m = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1,
                        d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    return `${y}-${m}-${d}`;
                }


            },

            //------------ end methods
        },
        watch: {
            period(val) {
                this.setCurrentPeriods(val);
            },
            compareDateRangeText1() {
                if (this.modalDate1 || this.modalDate2) {
                    this.period = null;
                }
            },
            compareDateRangeText2() {
                if (this.modalDate1 || this.modalDate2) {
                    this.period = null;
                }
            },
            compareDate: {
                handler() {
                    this.compareDates1 = [this.compareDate.dateTimeBegin1, this.compareDate.dateTimeEnd1];
                    this.compareDates2 = [this.compareDate.dateTimeBegin2, this.compareDate.dateTimeEnd2];
                },
                deep: true
            },
            organizationId(v) {
                this.organisation = v;
            }

        },
        created() {
            this.compareDates1 = [this.compareDate.dateTimeBegin1, this.compareDate.dateTimeEnd1];
            this.compareDates2 = [this.compareDate.dateTimeBegin2, this.compareDate.dateTimeEnd2];
            this.organisation = this.organizationId;
        },

    }
</script>